import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const config = {
    apiKey: "AIzaSyDQ-ffWkus5gPo40GP1HLsB0ffJdNyeXzE",
    authDomain: "globalbrain-ba498.firebaseapp.com",
    databaseURL: "https://globalbrain-ba498.firebaseio.com",
    projectId: "globalbrain-ba498",
    storageBucket: "globalbrain-ba498.appspot.com",
    messagingSenderId: "990226424134",
    appId: "1:990226424134:web:32c773bf29a1f28a0b8547"
};

const app = initializeApp(config);
export const firebaseDb = getFirestore(app);
